export default "__VITE_ASSET__DnKCrO$h__"